var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarthquakeRegulations = function SvgEarthquakeRegulations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 21.5C43 33.374 33.374 43 21.5 43S0 33.374 0 21.5 9.626 0 21.5 0 43 9.626 43 21.5Z",
    fill: "#F2FAF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "earthquake_regulations_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 12,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M10 12h22v20H10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#earthquake_regulations_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.281 31.999.055.001h3.526c.647 0 1.176-.54 1.176-1.2v-8.407h1.998c.54 0 .799-.684.387-1.044l-9.825-9.043a1.166 1.166 0 0 0-1.575 0l-9.826 9.043c-.4.36-.152 1.044.388 1.044h1.998V30.8c0 .66.53 1.201 1.175 1.201h3.526l.055-.001h6.942Z",
    fill: "#58B847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.113 18.664-2.044 3.892a.013.013 0 0 0 .011.02h2.731c.01 0 .016.01.012.018l-2.201 4.72a.013.013 0 0 0 .012.018h3.276c.012 0 .017.014.01.023l-3.208 3.302a.013.013 0 0 0-.002.015L21 33.331",
    stroke: "#fff",
    strokeWidth: 1.118,
    strokeLinecap: "round"
  }))));
};
export default SvgEarthquakeRegulations;